import VuexTypes from '@/store/types/index';

const OrdersTypes = VuexTypes.orders;
export default {
  [OrdersTypes.ORDERS_LIST]: (state, { data, status }) => {
    state.ordersList = { data, status };
  },
  [OrdersTypes.ORDERS_LIST_FILTERS]: (state, { data, status }) => {
    state.ordersListFilters = { data, status };
  },
  [OrdersTypes.ORDERS_CLASSIFIERS]: (state, { data, status }) => {
    state.ordersClassifiers = { data, status };
  },
  [OrdersTypes.ORDER_UPDATE_DATA]: (state, { data, status }) => {
    state.orderUpdateData = { data, status };
  },
  [OrdersTypes.ORDER_UPDATE]: (state, { data, status }) => {
    state.orderUpdate = { data, status };
  },
  [OrdersTypes.ORDER_CREATE]: (state, { data, status }) => {
    state.orderCreate = { data, status };
  },
  [OrdersTypes.ORDER_APPROVAL]: (state, { data, status }) => {
    state.orderApproval = { data, status };
  },
  [OrdersTypes.ORDER_DELETE]: (state, { data, status }) => {
    state.orderDelete = { data, status };
  },
  [OrdersTypes.ORDER_COPY]: (state, { data, status }) => {
    state.orderCopy = { data, status };
  },
  [OrdersTypes.ORDER_ATTACHMENTS]: (state, { data, status }) => {
    state.orderAttachments = { data, status };
  },
  [OrdersTypes.ORDER_UPDATE_ATTACHMENTS_STATUS]: (state, { data, status }) => {
    state.orderUpdateAttachmentsStatus = { data, status };
  },
  [OrdersTypes.ORDER_ADD_COMMENT_TO_ATTACHMENT]: (state, { data, status }) => {
    state.orderAddCommentToAttachment = { data, status };
  },
  [OrdersTypes.ORDER_DELETE_ATTACHMENT]: (state, { data, status }) => {
    state.orderDeleteAttachment = { data, status };
  },
  [OrdersTypes.ORDER_ACTIVITY]: (state, { data, status }) => {
    state.orderActivity = { data, status };
  },
  [OrdersTypes.ORDER_ITEMS]: (state, { data, status }) => {
    state.orderItems = { data, status };
  },
  [OrdersTypes.ORDER_CREATE_ITEM]: (state, { data, status }) => {
    state.orderCreateItem = { data, status };
  },
  [OrdersTypes.ORDER_UPDATE_ITEM]: (state, { data, status }) => {
    state.orderUpdateItem = { data, status };
  },
  [OrdersTypes.ORDER_DELETE_ITEM]: (state, { data, status }) => {
    state.orderDeleteItem = { data, status };
  },
  [OrdersTypes.ORDER_FACTS_AND_INVOICES_LIST]: (state, { data, status }) => {
    state.orderFactsAndInvoicesList = { data, status };
  },
  [OrdersTypes.ORDER_UPDATE_FACT]: (state, { data, status }) => {
    state.orderUpdateFact = { data, status };
  },
  [OrdersTypes.ORDER_APPROVE_FACT_AND_INVOICE]: (state, { data, status }) => {
    state.orderApproveFactAndInvoice = { data, status };
  },
  [OrdersTypes.ORDER_ITEMS_SEND_INVOICE_TO_BOOKKEEPER]: (state, { data, status }) => {
    state.orderItemsSendInvoiceToBookkeeper = { data, status };
  },
  [OrdersTypes.ORDER_ITEMS_APPROVE_INVOICE_REVIEW]: (state, { data, status }) => {
    state.orderItemsApproveInvoiceReview = { data, status };
  },
  [OrdersTypes.ORDER_ITEMS_DECLINE_INVOICE_REVIEW]: (state, { data, status }) => {
    state.orderItemsDeclineInvoiceReview = { data, status };
  },
  [OrdersTypes.ORDER_INVOICES_ADVANCE_LIST]: (state, { data, status }) => {
    state.orderInvoicesAdvanceList = { data, status };
  },
  [OrdersTypes.ORDER_APPROVE_INVOICE_ADVANCE]: (state, { data, status }) => {
    state.orderApproveInvoiceAdvance = { data, status };
  },
  [OrdersTypes.ORDER_REMOVE_INVOICE_ADVANCE]: (state, { data, status }) => {
    state.orderRemoveInvoiceAdvance = { data, status };
  },
  [OrdersTypes.ORDER_APPROVE_INVOICE_ADVANCE_REVIEW]: (state, { data, status }) => {
    state.orderApproveInvoiceAdvanceReview = { data, status };
  },
  [OrdersTypes.ORDER_DECLINE_INVOICE_ADVANCE_REVIEW]: (state, { data, status }) => {
    state.orderDeclineInvoiceAdvanceReview = { data, status };
  },
  [OrdersTypes.ORDER_SEND_INVOICE_ADVANCE_TO_BOOKKEEPER]: (state, { data, status }) => {
    state.orderSendInvoiceAdvanceToBookkeeper = { data, status };
  },
};
